import React, { useEffect, useState } from "react";
import "./CategoryGrid.css";
import { Link } from "react-router-dom";
import categoryService from "../../services/categoryService";

export default function CategoryGrid() {
  // const [categories, setCategories] = useState([]);
  // const [categoryTree, setCategoryTree] = useState([]);

  // const fetchCategories = async () => {
  //   try {
  //     const response = await categoryService.getCategoryTree();
  //     if (response?.success && response?.data) {
  //       console.log(response.data, "response category");
  //       setCategoryTree(response.data);
  //       const allCategories = flattenCategoriesWithParent(response.data);
  //       setCategories(allCategories);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching categories:", error);
  //   }
  // };
  // const flattenCategoriesWithParent = (categoriesTree, parent = null) => {
  //   let flat = [];
  //   categoriesTree.forEach((cat) => {
  //     flat.push({
  //       id: cat._id,
  //       name: cat.name,
  //       slug: cat.slug,
  //       parent: parent,
  //       rootParent: parent?.rootParent || parent,
  //     });
  //     if (cat.children && cat.children.length > 0) {
  //       flat = [
  //         ...flat,
  //         ...flattenCategoriesWithParent(cat.children, {
  //           id: cat._id,
  //           name: cat.name,
  //           parent: parent,
  //           rootParent: parent?.rootParent ||
  //             parent || { id: cat._id, name: cat.name },
  //         }),
  //       ];
  //     }
  //   });
  //   return flat;
  // };
  // useEffect(() => {
  //   fetchCategories();
  // }, []);
  return (
    <section className="category-grid-section">
      <div className="category-grid-container">
        <div className="category-items">
          <Link
            state={{ categoryList: true }}
            to="/products/sweaters"
            className="category-item"
          >
            <img src="/images/category/SWEATRS.png" alt="SWEATRS" />
            <h3>Sweaters</h3>
          </Link>

          <Link
            state={{ categoryList: true }}
            to="/products/rompers"
            className="category-item"
          >
            <img src="/images/category/ROMPER.png" alt="Winter Rompers" />
            <h3>Rompers</h3>
          </Link>

          <Link
            state={{ categoryList: true }}
            to="/products/Co-ord sets"
            className="category-item"
          >
            <img src="/images/category/WINETRSETS.png" alt="Winter Sets" />
            <h3>Co-ord sets</h3>
          </Link>

          <Link
            state={{ categoryList: true }}
            to="/products/bottoms"
            className="category-item"
          >
            <img src="/images/category/COMFYPANTS.png" alt="Nightsuits" />
            <h3>Bottoms</h3>
          </Link>

          <Link
            state={{ categoryList: true }}
            to="/products/dresses"
            className="category-item"
          >
            <img src="/images/category/PARTYDRESS.png" alt="Kurta Sets" />
            <h3>Party Dress</h3>
          </Link>

          <Link
            state={{ categoryList: true }}
            to="/products"
            className="category-item"
          >
            <img src="/images/category/WINTERSALE.png" alt="Winter Sale" />
            <h3>Winter Sale</h3>
          </Link>
        </div>
      </div>
    </section>
  );
}
